const isProduction = process.env.NODE_ENV === "production";


export  function  uuid() : string {
  let d = new Date().getTime(); //Timestamp
  let d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  const Newid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }

    

    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });



  return Newid;
}

export function betweenRandomNumber(min: number, max: number): number {
  return Math.floor(
    Math.random() * (max - min + 1) + min
  )
}

export function abbThaiMonth(number: number): string{
  const month = [
    "",
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];
  return month[number];
}

export function logger(message:string, ...args:string[] ) :void {
  if (!isProduction) console.log(message, args);
}

export function error(err:string) :void {
  if (!isProduction) console.error(err);
}


